import { Box, CircularProgress } from '@mui/material';

import { FProgressBar } from '../../../../../../../components/base';
import {
  EducationFields,
  useFormReadOnly,
  useSaveEducationFieldOnBlur,
} from '../../../../../../common';
import { useQuestionnaireFormik } from '../../../../../common/hooks';
import { intakeQuestionnaireActions } from '../../../../../../../store';
import { INTAKE_TAB_IDS } from '../../../../constants';
import {
  useIntakeEducationInfoUpdateLoading,
  useIntakeQuestionnaireLoading,
} from '../../../../hooks';
import { useEducationInfoInitialValues, useIntakeEducationInfo } from '../hooks';
import { EDUCATION_FORM_BOX_SX, EDUCATION_FORM_LOADING_OVERLAY_SX } from '../styles';
import { EDUCATION_INFO_SCHEMA } from '../validationSchema';

export default function EducationInfoSection() {
  const initialValues = useEducationInfoInitialValues();
  const isLoading = useIntakeQuestionnaireLoading();
  const isUpdating = useIntakeEducationInfoUpdateLoading();
  const { update } = useIntakeEducationInfo();
  const readOnly = useFormReadOnly();

  const formik = useQuestionnaireFormik({
    tabId: INTAKE_TAB_IDS.EDUCATION,
    initialValues,
    validationSchema: EDUCATION_INFO_SCHEMA,
    updateTabStatus: intakeQuestionnaireActions.updateIntakeTabStatus,
  });
  const { saveField } = useSaveEducationFieldOnBlur({
    formik,
    initialValues,
    validationSchema: EDUCATION_INFO_SCHEMA,
    onUpdate: update,
  });

  return (
    <Box component="form" noValidate onSubmit={formik.handleSubmit} sx={EDUCATION_FORM_BOX_SX}>
      {isUpdating ? <FProgressBar /> : null}
      {isLoading ? (
        <Box sx={EDUCATION_FORM_LOADING_OVERLAY_SX}>
          <CircularProgress size={32} />
        </Box>
      ) : null}
      <EducationFields
        disabled={isLoading}
        formik={formik}
        readOnly={readOnly}
        saveField={saveField}
      />
    </Box>
  );
}
